<div class="text-center" (mouseenter)="this.dotComService.DisplaySubMenu('')">
    <!-- Address Modal -->
    <div id="addressModal" class="modal">
        <!-- Modal content -->
        <div class="modal-content">
            <div class="row whiteBackground" style="text-align: left;">
                <h3 class="Caecilia76BoldItalic greenText" style="font-size: 24px; font-weight: 700;">
                    {{this.myHarrellsService.customerSelected}}</h3>
            </div>
            <div class="row whiteBackground mt-3 text-center">
                <h3 class="DIN2014Regular blackText" style="font-size:19px;line-height:30px">What address are you
                    ordering for?</h3>
            </div>
            <!-- addresses dropdown -->
            <div class="col-md-auto mt-2">
                <select
                    style="font-size:19px; line-height:20px; letter-spacing:.38px; font-weight:400;width:98%; height:50px; padding-left:0px;"
                    [(ngModel)]="this.myHarrellsService.addressSelected" (change)="AddressSelected()">
                    <!-- <option value="" disabled selected>Select A Size</option> -->
                    <option *ngFor="let address of this.addressesForAddressModalNoAllAddresses" class="DIN2014Regular">
                        <!-- value={{particleSize.Id}}> -->
                        {{address.Address1}}
                    </option>
                </select>
            </div>
            <div class="row whiteBackground mt-3">
                <h6 class="mt-3" style="text-align: right;"><a class="DIN2014 greenBackground whiteText"
                        style="cursor: pointer; font-size:20px; font-weight: 700; padding:8px; text-decoration: none !important"
                        (click)="CancelOnlineOrderAtAddressPrompt()">Cancel</a></h6>
            </div>
        </div>
    </div>
    <!-- End Address Modal -->

        <!-- How Polyon Works Modal -->
    <div id="howItWorksModal" class="modal">
        <!-- Modal content -->
        <div class="modal-content howItWorksModalVideoModalMobile">
            <video id="howItWorksVideo" class="howItWorksModalMobile" width="800" height="500" controls>
                <source src="{{this.baseImagePaths + 'How_POLYON_Works.mp4'}}" type="video/mp4">
                Your browser does not support the video tag.
            </video>
            <h6 style="text-align: right;margin-top:20px; margin-right:20px"><a
                    class="DIN2014 greenBackground whiteText"
                    style="font-size:20px; font-weight: 700; padding:8px; text-decoration: none !important"
                    (click)="ClosehowItWorksModal()">Close</a></h6>
        </div>
    </div>
        <!-- End How Polyon Works Modal -->

    <!-- desktop view -->
    <!-- <div
        *ngIf="this.myHarrellsService.bootstrapViewPortSize != 'xs' && this.myHarrellsService.bootstrapViewPortSize != 'sm'"> -->

    <div *ngIf="!this.myHarrellsService.onlineOrderingInEffect"
    class="headerImageHeight4" style="background-size: cover; background-position:center"
        [ngStyle]="{backgroundImage: 'url(' + this.pageImagePaths + 'header-image.png)'}">
        <div *ngIf="myHarrellsService.bootstrapViewPortSize != ''">
            <h1 *ngIf="myHarrellsService.bootstrapViewPortSize == 'xs' || this.myHarrellsService.bootstrapViewPortSize == 'sm'"
                class="DINNextLTPro-Black whiteText headerImageTextLarge" style=" text-transform: uppercase;">
                PRODUCTS</h1>
            <h1 *ngIf="myHarrellsService.bootstrapViewPortSize && myHarrellsService.bootstrapViewPortSize != '' && !(myHarrellsService.bootstrapViewPortSize == 'xs' || this.myHarrellsService.bootstrapViewPortSize == 'sm')"
                class="DINNextLTPro-Black whiteText headerImageTextLarge" style=" text-transform: uppercase;">
                CUSTOM FERTILIZER & PRODUCTS</h1>
        </div>
        <!-- <div class="row" *ngIf="myHarrellsService.bootstrapViewPortSize != ''">
            <div class="col text-center whiteText">
                <h1 class="DINNextLTPro-Black whiteText headerImageTextLarge">OUR PRODUCTS</h1>
            </div>
        </div> -->
        <!-- <div class="row" *ngIf="myHarrellsService.bootstrapViewPortSize && myHarrellsService.bootstrapViewPortSize != '' && !(myHarrellsService.bootstrapViewPortSize == 'xs' || this.myHarrellsService.bootstrapViewPortSize == 'sm')">
            <div class="col text-center" style="padding-right:25%; padding-left:25%; padding-top:2%; padding-bottom:2%">
                <h3 class="DIN2014Regular whiteText"
                    style="font-size:19px;font-weight: 400; line-height:30px; letter-spacing: .38px;">
                    Harrell’s is the leading distributor of branded fungicides, herbicides, and insecticides, and a
                    manufacturer of top-quality custom-blended fertilizer. Browse our products and reach out to your
                    Harrell’s rep with questions or to place an order.</h3>
            </div>
        </div>
        <div class="row" style="padding-bottom:3%" *ngIf="myHarrellsService.bootstrapViewPortSize && myHarrellsService.bootstrapViewPortSize != '' && !(myHarrellsService.bootstrapViewPortSize == 'xs' || this.myHarrellsService.bootstrapViewPortSize == 'sm')">
            <h3><a class="DIN2014Bold blueBackground whiteText"
                    style="font-size:20px;font-weight:700;padding:8pt; text-decoration: none !important"
                    href='/findrep'>FIND MY REP</a>
            </h3>
        </div> -->
    </div>




    <div id="productsFilterAnchor" class="row mt-5 mb-5 productsMainDiv" style="margin:auto">
        <div class="col-md-4 text-start">
            <h5 class="Caecilia86HeavyItalic greenText" *ngIf="this.myHarrellsService.onlineOrderingInEffect"
                (click)="ReturnToMyHarrells()"
                style="cursor:pointer; margin-left:15%; font-size:28px; font-weight:700; text-decoration-line: none;">
                &#8592; myHarrells</h5>


            <input Class="DIN2014Regular"
                style="display:inline;font-size:19px;line-height:30px;height:48px;width:254px;padding:14px"
                placeholder="Search Products" (blur)="FilterProductsFired()" (keyup.enter)="FilterProductsFired()"
                [(ngModel)]="this.dotComService.productSearch">
            <img src="{{this.baseImagePaths + 'SearchIcon.jpg'}}" alt="Search Icon"
                style="display:inline;height:20px;height:20px;margin-left:-34px">
            <img *ngIf="this.myHarrellsService.bootstrapViewPortSize == 'xs' || this.myHarrellsService.bootstrapViewPortSize == 'sm'"
                src="{{baseImagePaths + 'FilterIconDark.png'}}"
                style="cursor:pointer; width:60px; height:40px; position:absolute; right:10px" alt="filter icon"
                (click)="ToggleFilter()">
        </div>
        <div class="col-md-4 text-center pr-3" *ngIf="this.myHarrellsService.onlineOrderingInEffect">
            <h6 class="DIN2014Regular" *ngIf="this.myHarrellsService.thisAddressDetails != undefined"
                style="font-size:28px; font-weight:400; line-height:30px; margin-bottom:0; margin-left:5px">
                {{this.myHarrellsService.customerNmbrSelected}}</h6>
            <h6 class="DIN2014Regular" *ngIf="this.myHarrellsService.thisAddressDetails != undefined"
                style="display:inline-block;font-size:16px; font-weight:400; line-height:30px; margin-bottom:0; margin-left:5px">
                {{this.myHarrellsService.thisAddressDetails.Address1}}, {{this.myHarrellsService.thisAddressDetails.City}}, {{this.myHarrellsService.thisAddressDetails.State}}
                </h6>
            <a class="DIN2014Regular blueText"
                style="cursor:pointer;display:inline-block;font-size:16px; font-weight:400; line-height:30px; margin-bottom:0; margin-left:5px"
                (click)="OpenAddressModal()">edit</a>
            <h6 class="DIN2014Regular"
                style="font-size:16px; font-weight:400; line-height:30px; margin-bottom:0; margin-left:5px">Service
                Location: {{this.myHarrellsService.serviceLocation}}</h6>
        </div>
        <div class="col-md-4 text-center pr-3" *ngIf="!this.myHarrellsService.onlineOrderingInEffect"></div>
        <div class="col-md-4 text-end pr-3"
            *ngIf="this.myHarrellsService.bootstrapViewPortSize != 'xs' && this.myHarrellsService.bootstrapViewPortSize != 'sm'">
            <h4 class="Din2014Regular blackText"
                style="cursor:pointer; font-size:16px; font-weight:700; margin-left:20%; text-decoration: underline !important; margin-top:2%"
                (click)="ViewAllProducts()">VIEW ALL PRODUCTS</h4>
        </div>
    </div>
    <div class="row whiteBackground blackText adjWidthByscreensize" style="margin:auto">
        <div class="col-lg-3" style="padding-right:0px; padding-bottom:20px"
            [ngClass]="(this.myHarrellsService.bootstrapViewPortSize != 'xs' && this.myHarrellsService.bootstrapViewPortSize != 'sm') 
        || ((this.myHarrellsService.bootstrapViewPortSize == 'xs' || this.myHarrellsService.bootstrapViewPortSize == 'sm') && showFilterObjects ) ? '': 'hideFilterObjectsPanel' ">
            <h4 class="DIN2014Bold"
                style="text-decoration: underline; font-size:26px; font-size:700; text-align: left; text-decoration: none;">
                Filters</h4>

            <h4 class="DIN2014Bold"
                style=" font-size:19px; line-height:30px; font-weight:700; color:#006890; text-align: left"
                (click)="ViewAllProducts()">ALL</h4>

            <h4 class="DIN2014Bold"
                style=" font-size:19px; line-height: 30px; font-weight: 700; color:#006890; text-align: left; margin-right:25%;"
                (click)="ToggleExpand('Class')">
                PRODUCT TYPE
                <img *ngIf="!classExpanded" src="{{this.baseImagePaths + 'plus-icon.png'}}" alt="arrow down"
                    style="cursor:pointer;float:right;margin-top:10px">
                <img *ngIf="classExpanded" src="{{this.baseImagePaths + 'minus-icon.png'}}" alt="arrow down"
                    style="cursor:pointer;float:right;margin-top:10px">
            </h4>
            <div *ngIf="classExpanded">
                <div style="margin-bottom:14px">
                    <div *ngFor="let row of this.productClassesFiltered" style="text-align: left;">
                        <label>
                            <input type="radio" class="checkbox-round" style="width:10px; height:10px"
                                name="productsFilter" [id]="row.Class"
                                (change)="FilterProductsDisplay('Class',row,$event)">
                            <h6 class="DIN2014Regular"
                                style="display:inline-block;font-size:16px; font-weight:400; line-height:30px; color:#027D3C; margin-bottom:0; margin-left:5px">
                                {{row.Class}}</h6>
                        </label>
                    </div>
                </div>
                <!-- <div *ngFor="let row of this.productClassesFiltered" style="text-align: left">
                    <input type="checkbox" class="checkbox-round" [id]="row.Class"
                        (change)="FilterProductsDisplay('Class',row,$event)">
                    <h6 class="DIN2014Regular"
                        style="display:inline-block;font-size:16px; font-weight:400; line-height:30px; color:#027D3C; margin-bottom:0; margin-left:5px">
                        {{row.Class}}</h6>
                </div> -->
            </div>
            <h4 class="DIN2014Bold"
                style=" font-size:19px; line-height: 30px; font-weight: 700; color:#006890; text-align: left; margin-right:25%;"
                (click)="ToggleExpand('Category')">
                CATEGORY
                <img *ngIf="!categoryExpanded" src="{{this.baseImagePaths + 'plus-icon.png'}}" alt="arrow down"
                    style="cursor:pointer;float:right;margin-top:10px">
                <img *ngIf="categoryExpanded" src="{{this.baseImagePaths + 'minus-icon.png'}}" alt="arrow down"
                    style="cursor:pointer;float:right;margin-top:10px">
            </h4>
            <div *ngIf="categoryExpanded">
                <div style="margin-bottom:14px">
                    <div *ngFor="let row of this.productCategoriesFiltered" style="text-align: left">
                        <label>
                            <input type="radio" class="checkbox-round" style="width:10px; height:10px"
                                name="productsFilter" [id]="row.Category"
                                (change)="FilterProductsDisplay('Category',row,$event)">
                            <h6 class="DIN2014Regular"
                                style="display:inline-block;font-size:16px; font-weight:400; line-height:30px; color:#027D3C; margin-bottom:0; margin-left:5px">
                                {{row.Category}}</h6>
                        </label>
                    </div>
                </div>
                <!-- <div *ngFor="let row of this.productCategoriesFiltered" style="text-align: left">
                    <input type="checkbox" class="checkbox-round" [id]="row.Category"
                        (change)="FilterProductsDisplay('Category',row,$event)">
                    <h6 class="DIN2014Regular"
                        style="display:inline-block;font-size:16px; font-weight:400; line-height:30px; color:#027D3C; margin-bottom:0; margin-left:5px">
                        {{row.Category}}</h6>
                </div> -->
            </div>
            <h4 class="DIN2014Bold"
                style=" font-size:19px; line-height: 30px; font-weight: 700; color:#006890; text-align: left; margin-right:25%;"
                (click)="ToggleExpand('Brand')">
                BRAND
                <img *ngIf="!brandExpanded" src="{{this.baseImagePaths + 'plus-icon.png'}}" alt="arrow down"
                    style="cursor:pointer;float:right;margin-top:10px">
                <img *ngIf="brandExpanded" src="{{this.baseImagePaths + 'minus-icon.png'}}" alt="arrow down"
                    style="cursor:pointer;float:right;margin-top:10px">
            </h4>
            <div *ngIf="brandExpanded">
                <div style="margin-bottom:14px">
                    <div *ngFor="let row of this.productBrandsFiltered" style="text-align: left">
                        <label>
                            <input type="radio" class="checkbox-round" style="width:10px; height:10px"
                                name="productsFilter" [id]="row.Brand"
                                (change)="FilterProductsDisplay('Brand',row,$event)">
                            <h6 class="DIN2014Regular"
                                style="display:inline-block;font-size:16px; font-weight:400; line-height:30px; color:#027D3C; margin-bottom:0; margin-left:5px">
                                {{row.Brand}}</h6>
                        </label>
                    </div>
                </div>
            </div>
            <!-- combined brand and vednor dropdowns together so when they search on brand it also searches on vendor -->
            <!-- <h4 class="DIN2014Bold"
                    style=" font-size:19px; line-height: 30px; font-weight: 700; color:#006890; text-align: left; margin-right:25%" (click)="ToggleExpand('Vendor')">
                    VENDOR
                    <img *ngIf="!vendorExpanded"
                        src="{{this.baseImagePaths + 'plus-icon.png'}}" alt="arrow down"
                        style="cursor:pointer;float:right;margin-top:10px">
                    <img *ngIf="vendorExpanded"
                        src="{{this.baseImagePaths + 'minus-icon.png'}}" alt="arrow down"
                        style="cursor:pointer;float:right;margin-top:10px">
                </h4>
                <div *ngIf="vendorExpanded">
                    <div *ngFor="let row of this.productVendorsFiltered" style="text-align: left; margin-left:10px;">
                        <input type="checkbox" class="checkbox-round" [id]="row.Vendor"
                            (change)="FilterProductsDisplay('Vendor',row,$event)">
                        <h6 class="DIN2014Regular"
                            style="display:inline-block;font-size:16px; font-weight:400; line-height:30px; color:#027D3C; margin-bottom:0; margin-left:5px">
                            {{row.Vendor}}
                        </h6>
                    </div>
                </div> -->
        </div>
        <div class="col-lg-9" style="margin-bottom:3%;">
            <div class="row productRow">

                <!-- <div class="col-lg-4" [id]="'main' + row.ItemPosition" *ngFor="let row of this.dotComService.products; let i = index">
                    <div> {{ i + 1 }} {{ row.WebName.trim().length}} {{row.WebName.trim()}}</div>

                </div> -->

<!-- //onerror="this.onerror=null; src='https://harrellscomtest.blob.core.windows.net/harrellscomtest/assets/images/harrellsh.png'" -->
                <div class="col-lg-4" [id]="'main' + row.ItemPosition" *ngFor="let row of this.dotComService.products"
                    style="margin-bottom:3%">
                    <div [id]="'outer' + row.ItemPosition" (click)="this.ViewProductsDetail(row)">
                        <img style="height:234px;width:234px;object-fit:scale-down;border:solid 1px lightgray"
                            src={{row.ImageURL}}
                            alt="fertilizer image">
                        <h5 class="DIN2014Regular"
                            style="text-transform:uppercase; overflow:hidden; min-height:59px; max-height: 58px; height: 58px; font-size:21px; line-height: 26px; font-weight:400;padding-top:10px">
                            {{row.WebName}}</h5>
                        <!-- <h5 class="DIN2014Regular"
                                style="text-transform:uppercase; font-size:21px; line-height: 26px; font-weight:400;">
                                {{row.ItemNmbr}}</h5> -->
                        <h5 class="DIN2014Regular"
                            *ngIf="this.myHarrellsService.onlineOrderingInEffect && !this.EOPMode"
                            style="text-transform:uppercase; font-size:21px; line-height: 26px; font-weight:400;">
                            ${{row.SellingPrice}}</h5>
                        <h5 class="DIN2014Regular" *ngIf="this.myHarrellsService.onlineOrderingInEffect && this.EOPMode"
                            style="text-transform:uppercase; font-size:21px; line-height: 26px; font-weight:400;">
                            {{row.EQUOMQTY}} Available</h5>

                        <button [id]="'button' + row.ItemPosition" class="DIN2014Regular greenBackground whiteText"
                            [style.margin-top]="row.mt"
                            style="border:none; margin-left:auto; margin-right:auto; font-size:12px; line-height:27px; font-weight:700">DETAILS</button>



                        <!-- button to go to details page -->
                        <!-- <button *ngIf="row.WebName.length<21" [id]="'button' + row.ItemPosition"
                            class="DIN2014Regular greenBackground whiteText"
                            style="border:none; margin-left:auto; margin-right:auto; font-size:12px; line-height:27px; font-weight:700">DETAILS</button>

                        <button *ngIf="row.WebName.length>20 && row.WebName.length<41"
                            [id]="'button' + row.ItemPosition" class="DIN2014Regular greenBackground whiteText"
                            style="margin-top:26px; border:none; margin-left:auto; margin-right:auto; font-size:12px; line-height:27px; font-weight:700">DETAILS</button>



                        <button *ngIf="row.WebName.length>40" [id]="'button' + row.ItemPosition"
                            class="DIN2014Regular greenBackground whiteText"
                            style="margin-top:52px; border:none; margin-left:auto; margin-right:auto; font-size:12px; line-height:27px; font-weight:700">DETAILS</button> -->


                    </div>
                </div>
            </div>
            <div class="row moreButtonRow">
                <!-- [disabled]="this.dotComService.products.length >= this.dotComService.productsMasterList.length"
                    [ngClass]="{'grayOut': this.dotComService.products.length >= this.dotComService.productsMasterList.length}" -->
                <!-- <button *ngIf="this.EOPMode == false" -->
                <button *ngIf="!this.myHarrellsService.onlineOrderingInEffect && !loadedAll"
                    style="height:38px; width:131px;border:none; margin-top:5%; font-size:20px; line-height: 27px; font-weight:700;"
                    class="DINNextLTPro-Black greenBackground whiteText" (click)="LoadMoreProducts()">Load More
                </button>
            </div>
        </div>
    </div>

    <div class="row text-center" *ngIf="!this.myHarrellsService.onlineOrderingInEffect"
        style="background-size: cover; background-position:center; padding-bottom:50px; margin-left:0px; margin-right:0px"
        [ngStyle]="{backgroundImage: 'url(' + this.baseImagePaths + 'harrells-pattern-full.png)'}">
        <h3 class="DINNextLTPro-Black whiteText"
            style="font-size:30px; line-height:44px; text-align: center; margin-top:50px">
            Harrell’s is the exclusive United States owner,<br> formulator and distributor of POLYON®
            controlled-<br>release
            fertilizer.</h3>
        <h3 style="margin-top:25px"><a class="DIN2014Bold whiteBackground greenText"
                style="font-size:20PX ;padding:8pt; text-decoration: none !important" (click)="OpenhowItWorksModal()">HOW POLYON WORKS</a>
        </h3>
    </div>
    <app-takeabalancedapproach></app-takeabalancedapproach>
    <!-- <div style="background: rgb(209,203,184,.7); margin-right:-10px">
        <div class="row blackText text-center" *ngIf="!this.myHarrellsService.onlineOrderingInEffect"
            style="padding-top:80px;padding-bottom:70px; max-width: 1200px; margin: auto;">
            <div class="col-2"></div>
            <div class="col-lg-4 greenText" style="padding-top:3%; padding-right:40px; border-right:solid 1px black;">
                <h4 class="Caecilia76BoldItalic"
                    style="opacity:100%;text-align: right; margin-left:20%; font-size:28px; line-height: 36px;">
                    Take a Balanced<br>Approach to<br>Growth</h4>
                <h6 class="DIN2014Regular blackText"
                    style="margin-top:5%; text-align:right; margin-left:19%; font-size:19px; line-height:30px">
                    Harrell's Balanced Approach is a scientifically supported, integrated, and proactive use of
                    agronomic
                    resources to maximize plant health and consistency.</h6>
            </div>
            <div class="col-lg-4">
                <div class="row">
                    <div class="col-lg-6" style="padding-top:10%">
                        <div style="margin:auto;height:50px; width:50px;"><img style="margin-top:8px; width:50px"
                                src="{{this.pageImagePaths + 'soil-icon.png'}}" alt="soilIcon"></div>
                        <h4 class="DIN2014Bold blueText" style="margin-top:5%; font-size:19px">SOIL</h4>
                        <div style="margin:auto;height:50px; width:50px; padding-top:30px"><img
                                style="margin-top:8px; width:50px" src="{{this.pageImagePaths + 'water-icon.png'}}"
                                alt="soilIcon"></div>
                        <h4 class="DIN2014Bold blueText" style="margin-top:5%; font-size:19px; padding-top:30px">WATER
                        </h4>
                    </div>
                    <div class="col-lg-6" style="padding-top:10%">
                        <div style="margin:auto;height:50px; width:50px;"><img style="margin-top:8px; width:50px"
                                src="{{this.pageImagePaths + 'nutrition-icon.png'}}" alt="soilIcon"></div>
                        <h4 class="DIN2014Bold blueText" style="margin-top:5%; font-size:19px">NUTRITION</h4>
                        <div style="margin:auto;height:50px; width:50px; padding-top:30px"><img
                                style="margin-top:8px; width:50px" src="{{this.pageImagePaths + 'protection-icon.png'}}"
                                alt="soilIcon"></div>
                        <h4 class="DIN2014Bold blueText" style="margin-top:5%; font-size:19px; padding-top:30px">
                            PROTECTION
                        </h4>
                    </div>
                </div>
            </div>
            <div class="col-2"></div>
        </div>
    </div> -->
    <div class="row" *ngIf="!this.myHarrellsService.onlineOrderingInEffect">
        <div class="col-9" style="padding-top:5%">
            <h4 class="DIN2014Bold" style="text-align: LEFT; margin-left:20%; font-size:36px; line-height: 46px;">
                Don't grow it alone. Connect with your Harrell's rep for expert guidance, innovative solutions, and a
                partnership rooted in respect.</h4>
        </div>
        <div class="col-3" style="padding-top:3%">
        </div>
    </div>
    <div class="row" *ngIf="!this.myHarrellsService.onlineOrderingInEffect" style="padding-bottom:5%">
        <div class="col-9" style="padding-top:3%">
            <h3 class="connectWithRepBtn"><a class="DIN2014Bold greenBackground whiteText"
                    style="font-size:20PX ;padding:8pt; text-decoration: none !important" href='/findrep'>FIND YOUR
                    REP</a>
            </h3>
        </div>
    </div>

</div>